import { createSlice } from '@reduxjs/toolkit';

export const lottieAnimationData = createSlice({
  name: 'LOTTIE',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setAnimationData(state, action) {
      const { payload } = action;
      const { isRendererAvailable, submissionSuccessAnimationJsonString } =
        payload;

      if (isRendererAvailable !== undefined) {
        state.isRendererAvailable = isRendererAvailable;
      }

      if (submissionSuccessAnimationJsonString !== undefined) {
        state.submissionSuccessAnimation = submissionSuccessAnimationJsonString;
      }
    },

    setAnimationConfig(state, action) {
      const { payload } = action;
      state.loaderConfig = payload;
    },
  },
});

const { actions, reducer } = lottieAnimationData;

export const { setAnimationData, setAnimationConfig } = actions;

export default reducer;
